import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../../environment.js";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
//import { deleteCustomer } from "../services/deleteCustomer.js";
import SweetAlert from "sweetalert2-react";
import "../loader.css";
import Loader from "../../Components/Loader.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const ManageCustomerUsers = ({ history }) => {
  const [dap_customers, setCustomers] = useState([]);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(true);
  const [dap_cid, setCid] = useState([]);
  const [customerCount, setCustomerCount] = useState(0);

  useEffect(() => {
    // axios
    //   .get(
    //     environment.apiUrl +
    //       `customers?pageSize=500&page=0&sortProperty=createdTime&sortOrder=DESC`,
    //     {
    //       headers: {
    //         "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )

    //   .then((res) => {
    //     // const dap_customers = res.data.data;
    //     setCustomers(res.data.data);

    //     setLoader(false);
    //   })
    //   .catch((err) => {
    //     MySwal.fire({
    //       title: <p>{err?.response?.data?.message}</p>,
    //       type: "error",
    //     });
    //   });
    let partnerDetails = JSON.parse(localStorage.getItem("user"));
    console.log(partnerDetails._id);
    axios
      .post(environment.dap_url + "users/getUsersByfilters", {
        filters: {
          userType: "CUSTOMER_USER",
          parentId: partnerDetails._id,
          isDeleted: false,
        },
      })
      .then((res) => {
        console.log(res.data);
        setLoader(false);
        setCustomers(res.data);
        setCustomerCount(res.data.length);
        // customers_array = res.data;
        // console.log(customers_array);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const deleteHandler = (email, customerId) => {
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .post(environment.dap_url + "external_api/deleteCustomer", {
            email: email,
            userId: customerId,
            // headers: {
            //   "X-Authorization": "Bearer " + localStorage.getItem("token"),
            // },
          })
          .then((res) => {
            // console.log(res.data.data);
            MySwal.fire({
              title: <p>Customer has been successfully deleted!</p>,
              type: "success",
            });
            // history.push("/customer")
            window.location.reload();

            // .then((res) => {
            //   console.log(res);
            //   // const dap_customers = res.data.data;
            //   //setCustomers(res.data.data);
            //   setLoader(false);
            //  // setCid(res.data.data);
            // })
            // .catch((err) => {
            //   MySwal.fire({
            //     title: (
            //       <p>
            //         {err?.response?.data?.message ||
            //           "Customer deleted successfully"}
            //       </p>
            //     ),
            //     type: "error",
            //   });
            // });
          })
          .catch((err) => {
            MySwal.fire({
              title: <p>Customer deletion failed</p>,
              type: "error",
            });
          });
      }
    });
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "organization",
      text: "Organization",
      sort: true,
    },

    // {
    //   dataField: "email",
    //   text: "Email",
    //   sort: true,
    // },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "country",
      text: "Country",
      sort: true,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "isActive",
      text: "Status",
      sort: false,
      formatter: (_, row, rowIndex, formatExtraData) => {
        return <span>{row.isActive ? "Active" : "Inactive"}</span>;
      },
    },
    {
      dataField: "customerId",
      text: "Users",
      sort: false,
      formatter: (dataField, row) => {
        return (
          <div>
            <LinkContainer to={`/manageCustomer/users/` + dataField}>
              <Button
                variant="light"
                className="btn-sm"
                disabled={!row.isActive}
              >
                Users <i className="fa fa-user"></i>
              </Button>
            </LinkContainer>
          </div>
        );
      },
    },

    {
      dataField: "_id",
      text: "Delete",
      sort: false,
      formatter: (_, row, rowIndex, formatExtraData) => {
        return (
          <div>
            <Button
              variant="danger"
              className="btn-sm"
              onClick={() => deleteHandler(row.email, row.customerId)}
            >
              Delete <i className="fa fa-trash-o"></i>
            </Button>
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return loader ? (
    <Loader />
  ) : (
    <div>
      <>
        <div className="container-fluid">
          <NavbarNew />
          <h4 className="card-title">CUSTOMERS</h4>
          <div className="row">
            <div className="col-12">
              <ToolkitProvider
                keyField="id"
                bootstrap4
                data={dap_customers}
                columns={columns}
                search
              >
                {(props) => (
                  <div>
                    <div className="d-flex align-items-center">
                      <p className="mb-2 mr-2">Search in table:</p>
                      <SearchBar {...props.searchProps} />
                    </div>
                    <BootstrapTable
                      defaultSorted={defaultSorted}
                      pagination={paginationFactory()}
                      {...props.baseProps}
                      wrapperClasses="table-responsive"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default ManageCustomerUsers;
